import { WatchQueryFetchPolicy } from 'apollo-client'

export const DEFAULT_Q_POLICY: WatchQueryFetchPolicy = 'cache-and-network'
